"use strict";
var ApiPackageConfiguration = (function () {
    function ApiPackageConfiguration() {
    }
    ApiPackageConfiguration.allowsFlights = function (config) {
        if (!config || !config.flightRequirementType) {
            return false;
        }
        switch (config.flightRequirementType) {
            case ApiPackageConfiguration.required:
            case ApiPackageConfiguration.conditional:
            case ApiPackageConfiguration.optional:
                return true;
            case ApiPackageConfiguration.none:
            default:
                return false;
        }
    };
    ApiPackageConfiguration.requiresFlights = function (config) {
        if (!config || !config.flightRequirementType) {
            return false;
        }
        switch (config.flightRequirementType) {
            case ApiPackageConfiguration.required:
                // flights are always required if the type is required.
                return true;
            case ApiPackageConfiguration.conditional:
                // flights are required, unless an acknowledgement exists.
                // TODO: add logic to see if an acknowledgement exists! for now, return true.
                return true;
            default:
                return false;
        }
    };
    return ApiPackageConfiguration;
}());
ApiPackageConfiguration.none = 'None';
ApiPackageConfiguration.optional = 'Optional';
ApiPackageConfiguration.conditional = 'Conditional';
ApiPackageConfiguration.required = 'Required';
exports.ApiPackageConfiguration = ApiPackageConfiguration;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-package-configuration.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-package-configuration.model.js